import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    language: 'ru'
  },
  mutations: {
    setLanguage(state, value = 'ru') {
      state.language = value;
    }
  },
  actions: {
    setLanguage({ commit }, value) {
      try {
        localStorage.setItem('language', value);
      } catch (e) {}

      commit('setLanguage', value);
    },
    async loadLanguage({ dispatch }) {
      let savedLanguage = '';
      try {
        savedLanguage = localStorage.getItem('language') || '';
      } catch (e) {
        savedLanguage = '';
      }

      const language = savedLanguage ||
        String(navigator.languages && navigator.languages[0] || navigator.language || 'ru').split('-')[0];
      await dispatch('setLanguage', language);

      return language;
    }
  },
});
